import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const AccordionItem = (props) => {
    const { t } = useTranslation();
    const accordionPanel = useRef();
    const container = useRef();
    const opener = useRef();
    // const firstChildMargin = window.getComputedStyle(props?.parentRef?.firstChild as Element).getPropertyValue('margin-bottom');
    // useEffect(() => {
    //   let heightForFlex;
    //   if (props.flex && props.gap && props.parentHeight) {
    //     heightForFlex =
    //     console.log('children total height', heightForFlex);
    //   }
    // }, [props.parentHeight]);
    useEffect(() => {
        console.log('Update Height: ', props.accordionId, props.updateHeight);
        // actual animation
        if (props.flex && props.gap && props.parentHeight) {
            accordionPanel.current.style.height = props.expanded
                ? props.autoHeight
                    ? 'auto'
                    : `${(props === null || props === void 0 ? void 0 : props.parentHeight) - (container.current.clientHeight * props.childrenLength + props.gap * (props.childrenLength - 1))}px`
                : '0px';
        }
        else {
            accordionPanel.current.style.height = props.expanded ? (props.autoHeight ? 'auto' : `${accordionPanel.current.firstElementChild.scrollHeight}px`) : '0px';
        }
    }, [props.expanded, props.children, props.updateHeight, props.parentHeight]);
    return (React.createElement("div", { ref: container, className: (!props.miniAccordion ? 'accordion__item' : '') + (props.itemClass ? ' ' + props.itemClass : '') },
        React.createElement("button", { ref: opener, type: "button", id: props.accordionId, onClick: () => {
                props.onClick && props.onClick();
                props.onSelect();
                if (props.callbackOnOpen && !props.expanded) {
                    props.callbackOnOpen();
                }
                if (props.scrollToElement) {
                    props.scrollToElement(container.current, opener.current);
                }
            }, className: classNames(props.miniAccordion ? 'accordion__header--mini' : 'accordion__header', { accordion__panel_open: props.expanded, 'header--selected': props.elementActive }, props.headerClass ? props.headerClass : ''), "aria-expanded": props.expanded, "aria-controls": props.accordionId + '-panel', tabIndex: props.tabIndex || null },
            props.isTitleMarkup ? props.title : React.createElement("span", { className: "primary-s" + (props.miniAccordion ? ' accordion__header--underline' : '') }, props.title),
            !props.hideToggleButtons && !props.miniAccordion && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "header__open" },
                    React.createElement("span", { className: "text" }, t('button.show'))),
                React.createElement("i", { className: "header__close" },
                    React.createElement("span", { className: "text" }, t('button.hide'))))),
            props.miniAccordion &&
                React.createElement(React.Fragment, null,
                    !props.expanded && React.createElement("div", { className: "accordion__header--arrow-down" }),
                    props.expanded && React.createElement("div", { className: "accordion__header--arrow-up" }))),
        React.createElement("div", { ref: accordionPanel, className: classNames(`accordion__panel${!!props.contentClass ? ' ' + props.contentClass : ''}`, { accordion__panel_open: props.expanded }), role: "region", id: props.accordionId + '-panel', "aria-labelledby": props.accordionId },
            React.createElement("div", null,
                React.createElement(React.Fragment, null,
                    props.loading && React.createElement("p", { className: "pb-12" }, t('label.loading')),
                    props.children)))));
};
AccordionItem.defaultProps = {
    isTitleMarkup: false,
    type: 'div',
};
export default AccordionItem;
